<template>
  <div class="el-main">
    <EnglishResumeProfileCard :current-card-id="currentCardId" />
    <EnglishResumeAddressCard :current-card-id="currentCardId" />
    <EnglishResumeEduHistoryCard
      :basic-data="basicData"
      :current-card-id="currentCardId"
    />
    <EnglishResumeSkillsCard :current-card-id="currentCardId" />
    <EnglishResumeLicenseCard
      :basic-data="basicData"
      :current-card-id="currentCardId"
    />
    <EnglishResumeJobHistoryCard
      :basic-data="basicData"
      :current-card-id="currentCardId"
    />
    <EnglishResumePrMessageCard :current-card-id="currentCardId" />
    <EnglishResumeCreateDateCard :current-card-id="currentCardId" />

    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>作成した英語レジュメを確認</h2>
          <p>
            修正する場合は、プレビューの修正欄をクリックまたはステップを戻ることで修正することができます
          </p>
        </div>
      </div>
    </div>

    <div
      class="card"
      v-show="currentCardId == 'output'"
      v-if="getMode != 'production1'"
    >
      <CompletedOutputPanel
        :formatId="formatId"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled"
        :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyEnglishResumeFormatData,
  provideEnglishResumeFormatData,
  provideEnglishResumeHistories,
  useEnglishResumeHistories
} from '@/composables/format-edit/useEnglishResumeFormatData'
import EnglishResumeProfileCard from '@/components/format-edit/english-resume/EnglishResumeProfileCard.vue'
import EnglishResumeAddressCard from '@/components/format-edit/english-resume/EnglishResumeAddressCard.vue'
import EnglishResumeEduHistoryCard from '@/components/format-edit/english-resume/EnglishResumeEduHistoryCard.vue'
import EnglishResumeSkillsCard from '@/components/format-edit/english-resume/EnglishResumeSkillsCard.vue'
import EnglishResumeLicenseCard from '@/components/format-edit/english-resume/EnglishResumeLicenseCard.vue'
import EnglishResumeJobHistoryCard from '@/components/format-edit/english-resume/EnglishResumeJobHistoryCard.vue'
import EnglishResumePrMessageCard from '@/components/format-edit/english-resume/EnglishResumePrMessageCard.vue'
import EnglishResumeCreateDateCard from '@/components/format-edit/english-resume/EnglishResumeCreateDateCard.vue'
import CompletedOutputPanel from '@/components/format-edit/completed/CompletedOutputPanel.vue'

defineProps<{
  basicData: Record<string, unknown>
  formatId?: string
  currentCardId?: string
}>()

const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'english_resume',
  saveOtherName: 'rirekisho',
  createEmpty: createEmptyEnglishResumeFormatData
})
provideEnglishResumeFormatData(formatData)

const histories = useEnglishResumeHistories(formatData)
provideEnglishResumeHistories(histories)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)

const getMode = computed(() => process.env.VUE_APP_MODE)

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})
</script>
